import { render, staticRenderFns } from "./IkkatsuQuestionUpload.vue?vue&type=template&id=a0da36d4&"
import script from "./IkkatsuQuestionUpload.vue?vue&type=script&lang=ts&"
export * from "./IkkatsuQuestionUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports